// src/components/contacts/ContactsPage.tsx
import React, { useState } from 'react';
import { useContacts, Contact } from '../../hooks/useContacts'; // Note the ../../
import SynthwaveLayout from '../../components/layouts/SynthwaveLayout'; // Note the ../../
// Optionally import your CSV import or DeviceContactPicker if needed
// import ImportRecipients from '../components/invitations/ImportRecipients';
// import DeviceContactPicker from '../components/contacts/DeviceContactPicker';

function ContactsPage() {
  const { contacts, loading, addContact, updateContact, deleteContact } = useContacts();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  if (loading) {
    return (
      <SynthwaveLayout>
        <div className="synthwave-card">
          <p>Loading Contacts...</p>
        </div>
      </SynthwaveLayout>
    );
  }

  const handleAddContact = async () => {
    if (!name) return;
    await addContact({ name, email, phone });
    setName('');
    setEmail('');
    setPhone('');
  };

  return (
    <SynthwaveLayout>
      <div className="synthwave-card overflow-auto max-h-[80vh] w-11/12 max-w-4xl mb-16">
        <h1 className="synthwave-heading">Your Contacts</h1>

        <div className="synthwave-inner-card bg-white mb-6">
          <h3 className="text-2xl font-black mb-4">Add Contact</h3>
          <label>Name</label>
          <input
            className="synthwave-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <label>Email</label>
          <input
            className="synthwave-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <label>Phone</label>
          <input
            className="synthwave-input"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />

          <button className="synthwave-button" onClick={handleAddContact}>
            <span className="button-text">Add Contact</span>
          </button>
        </div>

        {/* DeviceContactPicker example */}
        {/* <div className="synthwave-inner-card bg-white mb-6">
          <h3 className="text-2xl font-black mb-4">Import From Device</h3>
          <DeviceContactPicker />
          {
            // For each selected device contact, call addContact(...)
          }
        </div> */}

        {/* Example CSV Import for contacts (if you want) */}
        {/* <div className="synthwave-inner-card bg-white mb-6">
          <h3 className="text-2xl font-black mb-4">Import from CSV</h3>
          <ImportRecipients 
            onImportComplete={(imported) => {
              // For each row in 'imported', call addContact(...)
            }}
          />
        </div> */}

        <div className="synthwave-inner-card bg-white">
          <h3 className="text-2xl font-black mb-4">Contacts List ({contacts.length})</h3>
          <ul className="space-y-2">
            {contacts.map((c: Contact) => (
              <li key={c.id} className="flex justify-between items-center">
                <div>
                  <span className="font-bold">{c.name}</span> 
                  {c.email && <span> | {c.email}</span>}
                  {c.phone && <span> | {c.phone}</span>}
                </div>
                <div>
                  <button
                    className="dashboard-action-button mr-2"
                    onClick={() => deleteContact(c.id!)}
                  >
                    <span className="dashboard-button-text">Delete</span>
                  </button>
                </div>
              </li>
            ))}
          </ul>
        </div>

      </div>
    </SynthwaveLayout>
  );
}

export default ContactsPage;